

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ProjectValuationExternalReportPage1 extends Vue {
  @Prop({ required: true, type: String }) companyName!: string;
}
